export class ChangeDigitalSignatureEventType {

	static SEND = {
		CHANGE_DG_SIGNATURE_SEND: 'CHANGE_DG_SIGNATURE_SEND',
		CHANGE_DG_SIGNATURE_CONFIRM: 'CHANGE_DG_SIGNATURE_CONFIRM'
	};

	static STEPS = {
		CHANGE_DG_SIGNATURE_RESET: 'CHANGE_DG_SIGNATURE_RESET',
		CHANGE_DG_SIGNATURE_WARNING: 'CHANGE_DG_SIGNATURE_WARNING'
	};

	static ERROR = 'CHANGE_DG_SIGNATURE_ERROR';
	static BUTTONS = 'CHANGE_DG_SIGNATURE_BUTTONS';

	static LOGIN = {
		SECURITY_CHECK: 'AUTH_SECURITY_CHECK',
		AUTH_MESSAGE: 'AUTH_MESSAGE',
		SMS_VALIDATION: 'SMS_VALIDATION',
		DEFINE_PASSWORD: 'DEFINE_PASSWORD',
		REDEFINE_PASSWORD: 'REDEFINE_PASSWORD'
	};

	static DEFINE_SUBSCRIBE = {
		FIRSTACCESS: 'FIRSTACCESS'
	};

	static AUTH_MESSAGE = {
		'LOAD_COMPLETE': 'AUTH_MESSAGE_LOAD_COMPLETE'
	};

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-digital-signature/change-digital-signature.event.type.ts